<div *ngIf="values">
  <select [(ngModel)]="value" (ngModelChange)="change()">
    <option *ngFor="let v of values" [value]="v">
      {{v}}
    </option>
  </select>
</div>
